import { useState } from 'react';

import { Modal, TextField } from '@atom/mui';

export type RenameModalProps = {
  open: boolean;
  name: string;
  loading: boolean;
  onCancel: () => void;
  onSave: (name: string) => void;
};

const RenameModal = ({
  open,
  name,
  loading,
  onCancel,
  onSave,
}: RenameModalProps) => {
  const [value, setValue] = useState(name ?? '');

  const handleConfirm = () => {
    onSave(value);
    onCancel();
  };

  const handleCancel = () => {
    setValue(name ?? '');
    onCancel();
  };

  return (
    <Modal
      title="Rename Inventory"
      open={open}
      loading={loading}
      onCancel={handleCancel}
      onConfirm={handleConfirm}
      confirmButtonText="Save"
    >
      <TextField
        label="Name"
        value={value}
        onChange={event => setValue(event.target.value)}
      />
    </Modal>
  );
};

export default RenameModal;
